import React, { useRef, useState } from 'react'
import { MinusOutlined, PlusOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Col, Row, Tooltip } from 'antd'
import './styles.scss'

export interface Feature {
  text: string;
  metadata?: any;
  selected: boolean;
  Description?: string;
}

interface FeatureCardProps {
  text: string;
  selected: boolean;
  Description?: string;
  onStatusChange: (newStatus: 'pending' | 'added') => void;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  text, selected, Description, onStatusChange
}) => {
  const [status, setStatus] = useState<'added' | 'pending'>(selected ? 'added' : 'pending')
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  const handleToggleStatus = () => {
    setStatus((prev) => {
      const newStatus = prev === 'pending' ? 'added' : 'pending'
      onStatusChange(newStatus)
      return newStatus
    })
  }

  return (
    <div className={`feature-card ${status === 'added' ? 'green' : ''}`}>
      <textarea
        ref={textAreaRef}
        className="feature-card__text"
        value={text}
        readOnly
      />
      <div className="feature-card__buttons">
        {Description && (
          <Tooltip title={Description}>
            <button type="button" className="feature-card__button" style={{ marginRight: 4 }}>
              <InfoCircleOutlined />
            </button>
          </Tooltip>
        )}
        <button type="button" className="feature-card__button" onClick={handleToggleStatus}>
          {status === 'added' ? <MinusOutlined /> : <PlusOutlined />}
        </button>
      </div>
    </div>
  )
}

/// feature cards for DescriptionBuilder page
interface FeatureCardsArrayProps {
  initialFeatures: { [category: string]: Feature[] };
  handleStatusChange: (newStatus: 'added' | 'pending', category: string, featureText: string) => void;
  showTitle?: boolean;
}
const CategoryOrder = [
  'Trim Packages',
  'Engine and Transmission Features',
  'Interior Features'
]

const categoryMapping: { [backendKey: string]: string } = {
  'trimPackages': 'Trim Packages',
  'engineTransmissionDrivetrainFeatures': 'Engine and Transmission Features',
  'interiorFeatures': 'Interior Features',
};

export const FeatureCardsArray: React.FC<FeatureCardsArrayProps> = ({
  initialFeatures,
  handleStatusChange,
  showTitle = true
}) => {
  const sortedCategories = Object.keys(initialFeatures).sort((a, b) => {
    const indexA = CategoryOrder.indexOf(a)
    const indexB = CategoryOrder.indexOf(b)
    return indexA - indexB
  })
  return (
    <div>
      {initialFeatures && sortedCategories.map((category) => (
        <Col span={24} key={category} style={{ marginBottom: 24 }}>
          {showTitle && <h2>{categoryMapping[category] || category}</h2>}
          <Row gutter={16}>
            {Array.isArray(initialFeatures[category]) && initialFeatures[category].map((feature, i) => (
              <Col key={`${category}-${feature.text}-${feature.selected}-${i}`} xs={12} sm={12} md={8} lg={8}>
                <FeatureCard
                  text={feature.text}
                  selected={feature.selected}
                  Description={feature.Description}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus, category, feature.text)
                  }}
                />
              </Col>
            ))}

          </Row>
        </Col>
      ))}
    </div>
  )
}
